window.toast = function (text, type) {
    if (!Sweetalert2) return;
    Sweetalert2({ toast: true, text: text, type: type, showConfirmButton: false, showCloseButton: false, position: 'top-end', timer: 2000 });
}
window.successToast = function ($message = null) {
    return toast($message || 'Success', 'success');
}
window.errorToast = function ($message = null) {
    return toast($message || 'Error', 'error');
}
